import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Style.
 */

const StyledDescriptionDiv = styled.div`
  padding-top: 4px;
  font-size: 12px;
`;

/*
 * Component.
 */

export const TeamTrialEndedBanner: FC = () => {
  const theme = useUserTheme();
  const [isBannerDismissed, setIsBannerDismissed] = useState(false);

  if (isBannerDismissed) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerCloseAction onClick={() => setIsBannerDismissed(true)} />
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>{renderTitle()}</BannerContentTitle>
        <StyledDescriptionDiv>{renderDescription()}</StyledDescriptionDiv>
      </BannerContent>
    </Banner>
  );
};

/*
 * Helpers.
 */

function renderTitle() {
  return <Trans id="banner-teamtrialend-title">Your free Team Trial has ended</Trans>;
}

function renderDescription() {
  return (
    <Trans id="banner-teamtrialend-description">
      Please ask your administrator about upgrading your plan to keep using Front.
    </Trans>
  );
}
